import React, { useContext, useState } from 'react'
import { Link } from 'react-router-dom'
import Nav from 'react-bootstrap/Nav'
import styled from 'styled-components'
import { JazeelContext } from '../../utils/JazeelContext'
import { BrandContext } from 'Brands/utils/BrandContext'
import i18n from 'i18n'

//import { logout } from '../../services/services'
import { NavLink } from 'react-router-dom'
import axios from '../../utils/API'
import { logout } from 'CampaignSystem/services/requests'
import { useHistory } from 'react-router-dom'
import Image from 'react-bootstrap/Image'
import logo from 'assets/images/campaign/logo.png'
import { RTL } from 'locales/currentLang'

const SideMenuContainer = styled.div`
  padding-right: 2em;
  .selected {
    background: #f7f7f7;
    color: #212529;
  }
  a {
    display: block;
    padding: 0.5rem 1rem;
    margin-top: 1em;
    border-radius: 0.25rem;
    text-align: ${props => props.theme.reverseDir};
    &:hover {
      text-decoration: none;
    }
  }
  .selected:before {
    content: '';
    display: inline-block;
    height: 0.25em;
    width: 1.875em;
    background: #3affd9;
    margin-${props => props.theme.dir}: 1.188em;
    margin-${props => props.theme.reverseDir}: -1em;
  }
  a:not(.selected) {
    color: #777;
    padding-left: 3.125em;
  }
  &.mobile {
    position: fixed;
    top: 0;
    ${props => props.theme.reverseDir}: 0;
    background: #212529;
    height: 100vh;
    width: 18.625em;
    z-index: 99999;
    .flex-column {
      padding-top: 6.125em;
    }
    .selected {
      background: none;
      color: #ffffff;

      font-size: 0.875em;
      font-weight: bold;
      line-height: 1.125em;
    }
  }
  @media screen and (max-width: 992px) {
    padding-right: 0;
  }
`
const Logout = styled(Nav.Item)`
  padding-top: 0;
  @media screen and (max-width: 576px) {
    padding-top: 3.125em;
  }
`
const Logo = styled(Image)`
  margin: auto;
  display: block;
  padding-top: 2em;
`
export default function SideMenuSection() {
  const {
    setAuth,
    pages,
    isMobile,
    mobileMenuOpen,
    setMobileMenuOpen,
    setUserData,
    userData,
  } = useContext(JazeelContext)
  const [lang, setLang] = useState(i18n.language === 'ar' ? 'English' : 'عربي')
  const { setBrandData, brandData } = useContext(BrandContext)
  const history = useHistory()
  const logoutFun = event => {
    history.push('/')
    setMobileMenuOpen(false)
    logout(event, setBrandData, setUserData)
  }
  const toggleLang = async e => {
    if (RTL()) {
      await i18n.changeLanguage('en')
      localStorage.setItem('i18nextLng', 'en')
      setLang('عربي')
      document.getElementsByTagName('html')[0].style.direction = 'ltr'
      window.location.pathname = '/en'
      //window.location.reload()
    } else {
      await i18n.changeLanguage('ar')
      localStorage.setItem('i18nextLng', 'ar')
      setLang('English')
      document.getElementsByTagName('html')[0].style.direction = 'rtl'
      window.location.pathname = '/ar'

      //window.location.reload()
    }
    setMobileMenuOpen(false)
  }
  return (
    <SideMenuContainer
      className={`flex-column ${
        mobileMenuOpen ? '' : 'd-none d-lg-none d-md-none d-sm-flex'
      }${isMobile ? 'mobile' : ''}`}
      aria-orientation="vertical"
      onClick={e => e.stopPropagation()}
    >
      <Logo src={logo} />
      <Nav defaultActiveKey="/" className="flex-column" variant="pills">
        {pages &&
          pages.map(page => (
            <Nav.Item key={page.name}>
              <NavLink
                activeClassName="selected"
                // eventKey={page.path}
                // as={Link}
                exact={true}
                to={page.path}
                onClick={() => setMobileMenuOpen(false)}
              >
                {page.name}
              </NavLink>
            </Nav.Item>
          ))}
      </Nav>
      <hr className="d-none d-sm-block" />
      {(brandData || userData) && (
        <Logout onClick={event => logoutFun(event)}>
          <Nav.Link eventKey="logout">{i18n.t('routes.logout')}</Nav.Link>
        </Logout>
      )}
      <a onClick={toggleLang}>{lang}</a>
    </SideMenuContainer>
  )
}
